import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { withAlert } from "react-alert";
import _ from "lodash";
import styled from "styled-components";
import Widget from "./components/Widget";
import DateWidget from "./components/DateWidget";
import Banner from "./components/Banner";
import AccessionWidget from "./components/AccessionWidget";
// import AccessionGraph from "./components/AccessionGraph";
import AccessionService from "../../services/AccessionService";
import Loading from "../../components/Loading";
import UserStore from "../../utils/UserStore";
import { Can } from "../../acl/can";
import SettingsService from "../../services/SettingsService";

const GraphWidget = styled(Widget)`
  height: 440px;
  overflow: hidden;
`;

class AccessionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingGraph: true,
      accessionGraphs: null,
      loadingAccessionData: false,
      accessionData: {},
      homeText: null
    };
  }

  componentDidMount() {
    const { setTitle } = this.props;
    setTitle("Painel de Adesão");

    this.getAccessionGraphs();
    this.getAccessionData();
    this.getHomeText();
  }

  getHomeText = async () => {
    const homeText = await SettingsService.getHomeText();
    if (homeText) {
      this.setState({ homeText });
    }
  };

  getAccessionGraphs = async () => {
    this.setState({ loadingGraph: true });
    try {
      const accessionGraphs = await AccessionService.getAccessionGraphs();
      this.setState({ accessionGraphs });
    } catch (e) {
      const { alert } = this.props;
      console.error(e);
      const message = _.get(
        e,
        "response.data.error.message",
        "Erro ao buscar gráficos de adesão"
      );
      alert.show(message, { title: "Erro" });
    } finally {
      this.setState({ loadingGraph: false });
    }
  };

  getAccessionData = async () => {
    this.setState({ loadingAccessionData: true });
    try {
      const accessionData = await AccessionService.getAccessionData();
      this.setState({ accessionData });
    } catch (e) {
      const { alert } = this.props;
      console.error(e);
      const message = _.get(
        e,
        "response.data.error.message",
        "Erro ao buscar dados de adesão"
      );
      alert.show(message, { title: "Erro" });
    } finally {
      this.setState({ loadingAccessionData: false });
    }
  };

  clickDetails = type => {
    const { history } = this.props;
    history.push(`/accession-panel/${type}`);
  };

  render() {
    const {
      loadingGraph,
      accessionGraphs,
      accessionData,
      loadingAccessionData,
      homeText
    } = this.state;

    return (
      <Grid container spacing={2}>
        <DateWidget sm={3} />
        <Widget sm={9}>
          <Banner
            userName={UserStore.getUserName().split(" ")[0]}
            homeText={homeText}
          />
        </Widget>

        {loadingAccessionData ? (
          <Widget sm={12}>
            <Loading />
          </Widget>
        ) : (
          <Can I="use module" a="accession">
            {accessionData.responsibles && (
              <AccessionWidget
                sm={6}
                label="Responsáveis"
                onClick={() => this.clickDetails("responsibles")}
              />
            )}

            {accessionData.students && (
              <AccessionWidget
                sm={6}
                label="Alunos"
                onClick={() => this.clickDetails("students")}
              />
            )}
          </Can>
        )}
        <Can I="use module" a="accessionGraphs">
          <GraphWidget sm={12} alignItems="start">
            {loadingGraph ? (
              <Loading />
            ) : (
              accessionGraphs && (
                <iframe
                  title="Accession Graphs"
                  src={accessionGraphs.dashboard}
                  frameBorder={0}
                  width="100%"
                  height="600px"
                  allowTransparency
                />
              )
            )}
          </GraphWidget>
        </Can>
      </Grid>
    );
  }
}

AccessionPanel.propTypes = {
  setTitle: PropTypes.func.isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired, // inject by withAlert
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired // inject by withRouter
};

export default withAlert()(withRouter(AccessionPanel));
